'use client'

// src/Minus.tsx
import { createIcon } from "@chakra-ui/icon";
import { jsx } from "react/jsx-runtime";
var MinusIcon = createIcon({
  displayName: "MinusIcon",
  path: /* @__PURE__ */ jsx("g", { fill: "currentColor", children: /* @__PURE__ */ jsx("rect", { height: "4", width: "20", x: "2", y: "10" }) })
});

export {
  MinusIcon
};
//# sourceMappingURL=chunk-3YJF2A4V.mjs.map